import { AppNotificacao } from 'sicarf-components'
import { getEstados, getAllMunicipiosByUf } from '@/services/municipioService'
import { cadastroCredenciado, editarCredenciado } from '@/services/credenciadoService'
import { getEditalById } from '@/services/editalService'
import { findAllTipoDocumentosGeomensor, findAllTipoDocumentosVistoriador } from '@/services/tipoDocumentoCredenciado'
import { deleteById } from '@/services/documentoService'
import { MENSAGENS_TIPO_DOCUMENTO_CREDENCIADO } from '@/constants/constants'
import {
  CADASTRO_EXTENSOES_DOCUMENTO,
  CADASTRO_EXTENSOES_FOTO_PERFIL,
  filtrarTiposDocumentosPorCadastro
} from '@/constants/cadastroPublico'
import {
  limparRascunhoCadastro,
  obterRascunhoCadastro,
  salvarRascunhoCadastro,
  temRascunhoCadastro
} from '@/store/cadastroCredenciadoRascunho'

export default {
  mixins: [AppNotificacao],

  data () {
    return {
      visualizarTermos: false,
      confirmarEmail: null,
      pessoaExistente: false,
      validaCampoTelefone: false,
      loading: false,
      tiposDocumentos: {
        tipos: [],
        obrigatorios: []
      },
      mensagensTipoDocumento: MENSAGENS_TIPO_DOCUMENTO_CREDENCIADO,
      url: 'publico/documentoCredenciado/upload',
      credenciadoExistente: false,
      edital: null,
      fone: '',
      credenciado: {
        documentos: [],
        pessoa: {
          pessoaFisica: {
            cpf: null,
            nome: null
          },
          email: null,
          telefones: [],
          endereco: {
            logradouro: null,
            numero: null,
            complemento: null,
            bairro: null,
            cep: null,
            uf: '',
            municipio: {
              nome: '',
              id: null
            },
            semNumero: false
          }
        },
        codigoIncra: null,
        codigoCrea: null,
        formacao: null
      },
      ufSolicitacao: null,
      ufMunicipiosCarregados: null,
      municipios: [],
      listMunicipios: [],
      estados: [],
      isEdicao: false,
      tipoDocumentoAtivo: null,
      tiposFormacoes: [
        { codigo: 'ENGENHEIRO_AGRONOMO', descricao: 'Engenheiro(a) Agrônomo' }
      ],
      tipoCadastro: '',
      idEdital: null,
      numeroTelefone: [],
      modalCancelarAberto: false
    }
  },

  computed: {
    // Usado no fluxo antigo (tipo escolhido antes do upload).
    extensoesDocumentoAtivo () {
      return this.tipoDocumentoAtivo?.codigo === 'FOTO_PERFIL'
        ? CADASTRO_EXTENSOES_FOTO_PERFIL
        : CADASTRO_EXTENSOES_DOCUMENTO
    },

    isFluxoPublico () {
      return !this.isEdicao
    }
  },

  methods: {
    async initCadastro () {
      this.loading = true
      this.idEdital = this.$route.params.idEdital

      if (this.$route.params.solicitacao) {
        this.isEdicao = true
        this.fillFormWithSolicitacao(this.$route.params.solicitacao)
      }

      try {
        this.edital = await getEditalById(this.idEdital)
        this.tipoCadastro = this.edital?.tipoEdital || ''
        this.estados = await getEstados()

        const tiposApi = this.tipoCadastro === 'VISTORIADOR'
          ? await findAllTipoDocumentosVistoriador()
          : await findAllTipoDocumentosGeomensor()

        if (this.isFluxoPublico) {
          const filtrados = filtrarTiposDocumentosPorCadastro(tiposApi, this.tipoCadastro)
          this.tiposDocumentos.tipos = filtrados.tipos
          this.tiposDocumentos.obrigatorios = filtrados.obrigatorios
        } else {
          this.tiposDocumentos.tipos = tiposApi
          const indexOutros = this.tiposDocumentos.tipos.findIndex(tipo => tipo.codigo === 'OUTROS')
          this.tiposDocumentos.obrigatorios = [...this.tiposDocumentos.tipos]

          if (indexOutros !== -1) {
            this.tiposDocumentos.obrigatorios.splice(indexOutros, 1)
          }
        }

        if (!this.edital?.id && !this.$route.params.solicitacao) {
          if (this.isFluxoPublico) {
            this.$router.push({ name: 'editais' })
          } else {
            window.location.replace(process.env.VUE_APP_SICARF_URL)
          }
        }
      } catch (e) {
        if (this.isFluxoPublico) {
          this.$router.push({ name: 'editais' })
        } else {
          window.location.replace(process.env.VUE_APP_SICARF_URL)
        }
      } finally {
        this.loading = false
      }
    },

    onSemNumeroCheck (checked) {
      if (checked) {
        this.credenciado.pessoa.endereco.numero = 0
        return
      }

      this.credenciado.pessoa.endereco.numero = null
    },

    handleChangeMunicipio (value) {
      const municipio = this.listMunicipios.find(item => item.nome === value)

      if (municipio) {
        this.credenciado.pessoa.endereco.municipio.nome = municipio.nome
        this.credenciado.pessoa.endereco.municipio.id = municipio.id
      } else {
        this.credenciado.pessoa.endereco.municipio.nome = value
      }
    },

    async removeDoc ({ row, index }) {
      this.confirmBox(this.$messages.DOCUMENTO_REMOVE_CONFIRM, this.$messages.TITULO_WARNING,
        () => {
          this.executarRemocaoDoc({ row, index })
        },
        () => {})
    },

    // Remoção efetiva (sem novo confirm). Usado pelo formulário novo,
    // que já confirma no CadastroConfirmDialog antes de emitir removeDoc.
    executarRemocaoDoc ({ row, index }) {
      if (!row) {
        return
      }

      if (row.id && typeof row.id !== 'string') {
        deleteById(row.id).then(() => {
          this.credenciado.documentos.splice(index, 1)
        }).catch(() => {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
            'Houve um erro ao remover o anexo.')
        })
        return
      }

      this.credenciado.documentos.splice(index, 1)
    },

    adicionaDoc (documento) {
      const tipo = documento.tipoDocumento || this.tipoDocumentoAtivo

      if (!tipo) {
        return
      }

      if (tipo.codigo !== 'OUTROS') {
        const documentoExistente = this.credenciado.documentos.find(item => {
          return item.tipoDocumento.codigo === documento.tipoDocumento.codigo
        })

        if (!documentoExistente) {
          this.credenciado.documentos.push({
            caminho: documento.fileKey,
            nome: documento.fileName,
            tipoDocumento: documento.tipoDocumento
          })
        } else {
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            `Já existe um anexo para o tipo ${tipo.descricao}.`
          )
        }
      } else {
        this.credenciado.documentos.push({
          caminho: documento.fileKey,
          nome: documento.fileName,
          tipoDocumento: documento.tipoDocumento
        })
      }
    },

    formularioPreenchido () {
      const endereco = this.credenciado.pessoa.endereco

      return this.credenciado.codigoCrea !== null ||
        this.credenciado.codigoIncra !== null ||
        this.credenciado.formacao !== null ||
        endereco.bairro !== null ||
        endereco.logradouro !== null ||
        endereco.numero !== null ||
        endereco.complemento !== null ||
        endereco.cep !== null ||
        !!endereco.uf ||
        !!(endereco.municipio && endereco.municipio.nome) ||
        this.credenciado.pessoa.pessoaFisica.cpf !== null ||
        this.credenciado.pessoa.pessoaFisica.nome !== null ||
        this.credenciado.pessoa.email !== null ||
        this.credenciado.pessoa.telefones.length > 0 ||
        this.numeroTelefone.length > 0 ||
        this.credenciado.documentos.length > 0 ||
        temRascunhoCadastro(this.idEdital || this.$route.params.idEdital)
    },

    salvarRascunhoFormulario () {
      if (!this.isFluxoPublico) {
        return
      }

      salvarRascunhoCadastro(this.idEdital, {
        credenciado: this.credenciado,
        confirmarEmail: this.confirmarEmail,
        numeroTelefone: this.numeroTelefone,
        fone: this.fone,
        validaCampoTelefone: this.validaCampoTelefone
      })
    },

    restaurarRascunhoFormulario () {
      if (!this.isFluxoPublico) {
        return false
      }

      const estado = obterRascunhoCadastro(this.idEdital)

      if (!estado) {
        return false
      }

      this.credenciado = estado.credenciado
      this.confirmarEmail = estado.confirmarEmail
      this.numeroTelefone = estado.numeroTelefone || []
      this.fone = estado.fone || ''
      this.validaCampoTelefone = !!estado.validaCampoTelefone

      return true
    },

    limparRascunhoFormulario () {
      limparRascunhoCadastro(this.idEdital || this.$route.params.idEdital)
    },

    cancelar () {
      if (this.formularioPreenchido()) {
        // Fluxo público usa o dialog do novo layout; edição mantém confirmBox.
        if (this.isFluxoPublico) {
          this.modalCancelarAberto = true
          return
        }

        this.confirmBox(
          this.$messages.CANCELAR_CADASTRO,
          this.$messages.TITULO_WARNING,
          this.executarCancelamento
        )
        return
      }

      this.executarCancelamento()
    },

    fecharModalCancelar () {
      this.modalCancelarAberto = false
    },

    confirmarCancelamento () {
      this.modalCancelarAberto = false
      this.executarCancelamento()
    },

    executarCancelamento () {
      this.limparRascunhoFormulario()

      if (this.isEdicao) {
        this.$router.push({ name: 'credenciado/solicitacoes' })
      } else if (this.isFluxoPublico) {
        this.$router.push({ name: 'editais' })
      } else {
        window.location.replace(process.env.VUE_APP_SICARF_URL)
      }
    },

    addTelefone (values) {
      if (this.numeroTelefone.length >= 3) {
        return
      }

      this.fone = ''
      this.validaCampoTelefone = false
      this.numeroTelefone.push(values)
    },

    removeTelefone (fone) {
      const index = this.numeroTelefone.indexOf(fone)

      if (index > -1) {
        this.numeroTelefone.splice(index, 1)
      }

      if (this.numeroTelefone.length === 0) {
        this.validaCampoTelefone = true
      }
    },

    redirect () {
      if (!this.credenciado.id) {
        if (this.isFluxoPublico) {
          this.$router.push({
            name: 'credenciados/cadastro/confirmacao',
            params: { idEdital: this.idEdital },
            query: { email: this.credenciado.pessoa.email }
          })
        } else {
          window.location.replace(process.env.VUE_APP_SICARF_URL)
        }
      } else {
        this.$router.push({ name: 'credenciado/solicitacoes' })
      }
    },

    async cadastrar () {
      this.visualizarTermos = false
      this.loading = true
      this.credenciado.pessoa.telefones = this.numeroTelefone.map(item => ({ numero: item }))
      this.credenciado.idEdital = this.idEdital

      let sucessCadastrar = null
      let sucessRetificar = null

      if (!this.credenciado.id) {
        try {
          sucessCadastrar = await cadastroCredenciado(this.credenciado)
        } catch (e) {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, e.response.data)
        }
      } else {
        sucessRetificar = await editarCredenciado(this.credenciado)
      }

      if (sucessCadastrar) {
        this.limparRascunhoFormulario()

        if (this.isFluxoPublico) {
          this.redirect()
          return
        }

        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.CADASTRADO_SUCESSO
        )
        setTimeout(() => this.redirect(), 3000)
      }

      if (sucessRetificar) {
        this.limparRascunhoFormulario()
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.SOLICITACAO_RETIFICADA_SUCESSO
        )
        setTimeout(() => this.redirect(), 3000)
      } else {
        this.credenciado.pessoa.telefones = this.numeroTelefone.map(item => item.numero)
        this.loading = false
      }
    },

    async confirmarTermos () {
      this.validaCampoTelefone = this.numeroTelefone.length === 0

      if (this.pessoaExistente) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.USUARIO_EXISTENTE
        )
      }

      if (this.credenciadoExistente && !this.pessoaExistente) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.CREDENCIADO_CADASTRADO_EDITAL
        )
      } else if (await this.$refs.observer.validate()) {
        if (this.numeroTelefone.length === 0) {
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            'Nenhum telefone foi adicionado!'
          )
          this.validaCampoTelefone = true
          return
        }

        if (!this.pessoaExistente) {
          this.visualizarTermos = true
        }
      } else if (!this.pessoaExistente || this.numeroTelefone.length === 0) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.WARNING_VALIDACAO_FINALIZAR_CADASTRO
        )
      }
    },

    async changeUf (value) {
      this.credenciado.pessoa.endereco.municipio = {
        nome: '',
        id: null
      }
      this.ufSolicitacao = value
      await this.handleMunicipios(value)
    },

    async handleMunicipios (value) {
      if (!value) {
        return
      }

      if (this.ufMunicipiosCarregados === value && this.municipios.length > 0) {
        this.listMunicipios = this.municipios
        return
      }

      this.municipios = await getAllMunicipiosByUf(value)
      this.listMunicipios = this.municipios
      this.ufMunicipiosCarregados = value
    },

    fillFormWithSolicitacao (solicitacao) {
      const telefones = []

      this.credenciado.id = solicitacao.credenciado.id
      this.credenciado.dataCadastro = solicitacao.dataCadastro
      this.credenciado.pessoa.pessoaFisica.cpf = solicitacao.credenciado.pessoa.cpfCnpj
      this.credenciado.pessoa.id = solicitacao.credenciado.pessoa.id
      this.credenciado.pessoa.tipo = solicitacao.credenciado.pessoa.tipo
      this.credenciado.pessoa.dataCadastro = solicitacao.credenciado.pessoa.dataCadastro
      this.credenciado.pessoa.pessoaFisica.id = solicitacao.credenciado.pessoa.pessoaFisica.id
      this.credenciado.pessoa.pessoaFisica.nome = solicitacao.credenciado.pessoa.nomeRazaoSocial
      this.credenciado.pessoa.email = solicitacao.credenciado.pessoa.email
      this.confirmarEmail = solicitacao.credenciado.pessoa.email

      solicitacao.credenciado.pessoa.telefones.forEach(tel => {
        telefones.push(tel.numero)
      })

      this.credenciado.pessoa.telefones = telefones
      this.numeroTelefone = telefones
      this.credenciado.codigoCrea = solicitacao.credenciado.codigoCrea
      this.credenciado.codigoIncra = solicitacao.credenciado.codigoIncra
      this.credenciado.formacao = solicitacao.credenciado.formacao
      this.credenciado.pessoa.endereco = solicitacao.credenciado.pessoa.endereco
      this.municipios.push(this.credenciado.pessoa.endereco.municipio)
      this.credenciado.documentos = solicitacao.credenciado.documentos
      this.ufSolicitacao = solicitacao.credenciado.pessoa.endereco.uf
    },

    searchMunicipio (query) {
      if (query !== '') {
        this.listMunicipios = this.municipios.filter(value => {
          const municipios = value.nome.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          const searchQuery = query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')

          return municipios.indexOf(searchQuery) > -1
        })
      } else {
        this.listMunicipios = this.municipios
      }
    },

    changeTipoDocumentoAtivo (tipo) {
      this.tipoDocumentoAtivo = tipo
    },

    atualizarTipoDocumento (documento, tipo) {
      documento.tipoDocumento = tipo
    }
  }
}
